import { render, staticRenderFns } from "./HisInfoUserSelectDialog.vue?vue&type=template&id=24e90e8c&scoped=true&"
import script from "./HisInfoUserSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./HisInfoUserSelectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e90e8c",
  null
  
)

export default component.exports